const global = window

inputs.fn.selectTable = {
    update(input, data, inputData, response) {
        input.find('tbody').html('');
        $.each(response.data, function(key, value) {
            let row = $('<tr class="table__row" data-id="'+value[0]+'" data-value="'+value[0]+'">')
            let cell = $('<td class="cell cell--cell cell table__cell"><span class="cell__wrap"><span class="icon ico" data-ico="' + value[2] + '"></span><span class="cell__info info">' + value[1] + '</span></span></td>')
            row.append(cell)
            input.find('tbody').append(row)
        })
        inputs.fn.selectTable.init(input);
    },
    init(input) {
        input.find('tr').click(function () {
            input.find('tr.selected').removeClass('selected')
            $(this).addClass('selected')
            input.change()
        })
        if (input.find('tr.selected').length) {
            input.closest('.table__wrap').animate({
                scrollTop: input.find('tr.selected').position().top -40
            }, 500)
        }
    }
}

inputs.types.selectTable = function (data, name, niceName, type, input, parent, inputWindow) {
    inputs.fn.selectTable.init(input);
    data.update = function(inputData, response) {inputs.fn.selectTable.update(input, data, inputData, response)}

    return data
}
